module.exports = __webpack_public_path__ + "static/byrne-8635ccd2d82ae08b280a09366b269b83.gif";